import dynamic from 'next/dynamic';
import React from 'react';

const DynamicSlider = dynamic(
  () => import('react-slick').then(mod => mod.default as any),
  {
    ssr: false,
    loading: () => <div />,
  },
) as React.FC<any>;

export default DynamicSlider;
